// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.narrow-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding-bottom: 100px;
}
.narrow-container .widget {
  border: 1px solid #89949f !important;
  box-shadow: rgba(13, 26, 38, 0.15) 0px 2px 6px 0px !important;
}

.tell-us-more {
  height: max(500px, var(--centeringHeight));
}

.image-button {
  padding: 10px 15px;
  border: 1.5px solid #d4d4d4;
  border-radius: 5px;
  margin-bottom: 10px;
}
.image-button:hover {
  background-color: #F1F7FD;
}
.image-button.selected {
  background-color: #F1F7FD;
  border: 1.5px solid var(--linkColour);
}

.thank-you {
  height: max(240px, var(--centeringHeight));
}

.md-form {
  margin-bottom: 0.1rem !important;
  margin-top: 0.9rem !important;
}

.almost-there-text {
  font-size: 0.875rem;
  font-weight: 400;
}

.radio-label {
  font-size: 1rem;
  font-weight: 500;
}

.verification-image-label {
  font-weight: 600;
  font-size: 19px;
  margin-bottom: 15px;
}

.error-message {
  margin-left: 10px;
  position: relative;
  height: 5px !important;
  margin-bottom: 20px;
}

.doc-type-form .fa.fa-check, .uploaded-docs .fa.fa-check {
  font-size: 15px;
  color: var(--successColour);
}
.doc-type-form .custom-control-label, .uploaded-docs .custom-control-label {
  font-size: 15px;
}

.check-mark {
  display: inline-block;
  width: 25px;
}

.upload-disabled {
  opacity: 0.5;
  filter: grayscale(100%);
}

.spinner-icon {
  position: absolute;
  left: 40px;
  top: 35px;
  font-size: 20px;
  z-index: 1;
}

.uploaded-image-img {
  object-fit: cover;
  height: 100%;
  width: 100%;
  border-radius: 5px;
}

.uploaded-image-item {
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 5px;
  z-index: 2;
}

.uploaded-image-container {
  background-color: #ddd;
  position: relative;
  border-radius: 5px;
  height: 100px;
  width: 100px;
}

.remove-image-button {
  z-index: 3;
  position: absolute;
  background-color: #ddd;
  color: #333;
  display: inline-block;
  height: 22px;
  border-radius: 0 4px 0 5px;
  text-align: center;
  right: 0px;
  width: 22px;
  line-height: 22px;
  text-align: center;
  cursor: pointer;
}

.uploaded-label {
  font-size: 15px;
  font-weight: 500;
  display: inline-block;
}

.category-name {
  font-size: 0.775rem;
  line-height: 1.6rem;
  height: 1.8rem;
  font-weight: 500;
}

.box-header {
  background-color: #888;
  color: #fff;
  border-radius: 5px 5px 0 0;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/home/user-pending/user-pending.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;AACF;AACE;EACE,oCAAA;EACA,6DAAA;AACJ;;AAGA;EACE,0CAAA;AAAF;;AAGA;EACE,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;AAAF;AAEE;EACE,yBAAA;AAAJ;AAGE;EACE,yBAAA;EACA,qCAAA;AADJ;;AAKA;EACE,0CAAA;AAFF;;AAKA;EACE,gCAAA;EACA,6BAAA;AAFF;;AAKA;EACE,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;AAFF;;AAOE;EACE,eAAA;EACA,2BAAA;AAJJ;AAOE;EACE,eAAA;AALJ;;AASA;EACE,qBAAA;EACA,WAAA;AANF;;AASA;EACE,YAAA;EACA,uBAAA;AANF;;AASA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;AANF;;AASA;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AANF;;AASA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,UAAA;AANF;;AAUA;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AAPF;;AAUA;EACE,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;AAPF;;AAUA;EACE,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAPF;;AAUA;EACE,sBAAA;EACA,WAAA;EACA,0BAAA;AAPF","sourcesContent":[".narrow-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  padding-bottom: 100px;\n\n  .widget {\n    border: 1px solid #89949f !important;\n    box-shadow: rgba(13, 26, 38, 0.15) 0px 2px 6px 0px !important;\n  }\n}\n\n.tell-us-more {\n  height: max(500px, var(--centeringHeight))\n}\n\n.image-button {\n  padding: 10px 15px;\n  border: 1.5px solid #d4d4d4;\n  border-radius: 5px;\n  margin-bottom: 10px;\n\n  &:hover {\n    background-color: #F1F7FD;\n  }\n\n  &.selected {\n    background-color: #F1F7FD;\n    border: 1.5px solid var(--linkColour);\n  }\n}\n\n.thank-you {\n  height: max(240px, var(--centeringHeight))\n}\n\n.md-form {\n  margin-bottom: 0.1rem !important;\n  margin-top: 0.9rem !important;\n}\n\n.almost-there-text {\n  font-size: 0.875rem;\n  font-weight: 400;\n}\n\n.radio-label {\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.verification-image-label {\n  font-weight: 600;\n  font-size: 19px;\n  margin-bottom: 15px;\n}\n\n.error-message {\n  margin-left: 10px;\n  position: relative;\n  height: 5px !important;\n  margin-bottom: 20px;\n}\n\n.doc-type-form, .uploaded-docs {\n\n  .fa.fa-check {\n    font-size: 15px;\n    color: var(--successColour)\n  }\n\n  .custom-control-label {\n    font-size: 15px;\n  }\n}\n\n.check-mark {\n  display: inline-block;\n  width: 25px;\n}\n\n.upload-disabled {\n  opacity: 0.5;\n  filter: grayscale(100%);\n}\n\n.spinner-icon {\n  position: absolute;\n  left: 40px;\n  top: 35px;\n  font-size: 20px;\n  z-index: 1\n}\n\n.uploaded-image-img {\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n  border-radius: 5px;\n}\n\n.uploaded-image-item {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  border-radius: 5px;\n  z-index: 2\n\n}\n\n.uploaded-image-container {\n  background-color: #ddd;\n  position: relative;\n  border-radius: 5px;\n  height: 100px;\n  width: 100px;\n}\n\n.remove-image-button {\n  z-index: 3;\n  position: absolute;\n  background-color: #ddd;\n  color: #333;\n  display: inline-block;\n  height: 22px;\n  border-radius: 0 4px 0 5px;\n  text-align: center;\n  right: 0px;\n  width: 22px;\n  line-height: 22px;\n  text-align: center;\n  cursor: pointer;\n}\n\n.uploaded-label {\n  font-size: 15px;\n  font-weight: 500;\n  display: inline-block;\n}\n\n.category-name {\n  font-size: 0.775rem;\n  line-height: 1.6rem;\n  height: 1.8rem;\n  font-weight: 500;\n}\n\n.box-header {\n  background-color: #888;\n  color: #fff;\n  border-radius: 5px 5px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
